import { api } from '../api';

export const userAttributesService = {
  get: (userId: string, key: string) => api.get(`user-attributes/user/${userId}/key/${key}`),
  getById: (id: string) => api.get(`user-attributes/${id}`),
  getAllByUserId: (userId: string) => api.get(`user-attributes/${userId}`), 
  create: (data: any) => api.post('user-attributes', data),
  update: (data: any) => api.put('user-attributes', data),
  delete: (id: string) => api.delete(`user-attributes/${id}`),
  removeValue: (id: string) => api.delete(`user-attributes/values/${id}`),
  updateValue: (id: string, data: any) => api.put(`user-attributes/values/${id}`, data),
  createWithFile: async (formData: FormData) => {
    const response = await api.post('user-attributes', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  },
  updateValueWithFile: async (id: string, formData: FormData) => {
    const response = await api.put(`user-attributes/values/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  },
};